export function convertObjectToFormData(
  formData: FormData,
  object: Record<string, any>,
  rootKey: string = ""
) {
  Object.keys(object).map((key) => {
    const value = object[key] === null ? "" : object[key];
  
    if (value instanceof Array) {
      convertArrayToFormData(formData, value, key);
    } else {
      formData.append(rootKey + key, value);
    }
  });
}

export function convertArrayToFormData(
  formData: FormData,
  array: any[],
  key: string = ""
) {
  for (let index = 0; index < array.length; index++) {
    const currentKey = `${key}[${index}]`;
    if (typeof array[index] === "object") {
      convertObjectToFormData(formData, array[index], `${currentKey}.`);
    } else {
      formData.append(currentKey, array[index]);
    }
  }
}
